/* Presentation only: the single genuine Releasit app owns opening and ordering.
 * No source merchant globals, cart/order calls, app state or customer-field writes. */
(() => {
  'use strict';
  const ROOT = '[data-olla-final]';
  const NATIVE = '#_rsi-buy-now-button-overwrite,#_rsi-buy-now-button,#rsi_buy_now_button,._rsi-buy-now-button-product';
  const controllers = new WeakMap();
  const visible = node => Boolean(node?.isConnected && !node.closest('[hidden],[inert]') && node.getClientRects().length && getComputedStyle(node).display !== 'none' && getComputedStyle(node).visibility !== 'hidden');
  function mount(root) {
    if (controllers.has(root)) return;
    const abort = new AbortController(), owned = new Map();
    const owner = root.querySelector('[data-olla-native-owner]');
    if (!owner) return;
    let frame = 0;
    const control = () => {
      const matches = [...new Set(owner.querySelectorAll(NATIVE))].filter(visible);
      return root.dataset.nativeReady === 'true' && matches.length === 1 ? matches[0] : null;
    };
    function attribute(node, name, value) {
      const key = node;
      if (!owned.has(key)) owned.set(key, new Map());
      const props = owned.get(key);
      if (!props.has(name)) props.set(name, {before: node.getAttribute(name), after: value});
      props.get(name).after = value;
      if (node.getAttribute(name) !== value) node.setAttribute(name, value);
    }
    function decorate() {
      frame = 0;
      const button = control();
      if (!button) return;
      // Override only this product's rendered CTA; app configuration is untouched.
      attribute(button, 'style', 'background:linear-gradient(135deg,#f0cd7a,#d4a84f)!important;color:#1b1409!important;border-radius:13px!important;border:1px solid #b5832e!important;box-shadow:0 5px 16px #9a681f25!important;font-size:17.6px!important;');
      if (button.tagName !== 'BUTTON' && button.tagName !== 'A') {
        attribute(button, 'role', 'button'); attribute(button, 'tabindex', '0');
      }
      // Keep the existing direct-child SPAN node and handler ownership intact.
      const copies = [...button.children].filter(node => node.tagName === 'SPAN');
      if (copies.length !== 1) return;
      const copy = copies[0];
      if (!copy.dataset.ollaSourceCopy) {
        const originalNodes = [...copy.childNodes].map(node => node.cloneNode(true));
        const original = copy.innerHTML;
        copy.replaceChildren(document.createTextNode('Paga contraentrega'));
        const subtitle = document.createElement('span');
        subtitle.className = '_rsi-buy-now-button-subtitle'; subtitle.textContent = 'ordena aqui';
        copy.append(subtitle); copy.dataset.ollaSourceCopy = '';
        copy.__ollaOriginalCopy = {originalNodes, after: copy.innerHTML, original};
      }
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(decorate); };
    root.addEventListener('click', event => {
      const bridge = event.target.closest?.('[data-olla-scroll-native]');
      if (!bridge || !root.contains(bridge)) return;
      event.preventDefault();
      owner.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      (control() || owner).focus({preventScroll: true});
    }, {signal: abort.signal});
    root.addEventListener('keydown', event => {
      const button = control();
      if (event.target !== button || !['Enter', ' '].includes(event.key) || button.matches('button,a') || event.repeat) return;
      event.preventDefault();
      // Equivalent keyboard activation of the genuine owner, never a submit.
      const copies = [...button.children].filter(node => node.tagName === 'SPAN' && visible(node));
      if (copies.length === 1) copies[0].click();
    }, {signal: abort.signal});
    const observer = new MutationObserver(schedule);
    observer.observe(owner, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
    function cleanup() {
      abort.abort(); observer.disconnect(); cancelAnimationFrame(frame);
      owner.querySelectorAll('[data-olla-source-copy]').forEach(copy => {
        const state = copy.__ollaOriginalCopy;
        if (state && copy.innerHTML === state.after) copy.replaceChildren(...state.originalNodes);
        delete copy.dataset.ollaSourceCopy; delete copy.__ollaOriginalCopy;
      });
      owned.forEach((props, node) => props.forEach((state, name) => {
        if (node.getAttribute(name) !== state.after) return;
        if (state.before == null) node.removeAttribute(name); else node.setAttribute(name, state.before);
      }));
      controllers.delete(root);
    }
    controllers.set(root, cleanup);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) cleanup();
    }, {signal: abort.signal});
    schedule();
  }
  document.querySelectorAll(ROOT).forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll(ROOT).forEach(mount));
})();
